module.exports = __webpack_public_path__ + "static/media/ge.2200a47a.jpeg";